import React from 'react';

export const LoadingSpinner = () => (
  <div className="loading-full">
    <span className="spinner"></span>
  </div>
);

export const EmptyState = ({ icon = '📭', title, message }) => (
  <div className="empty">
    <div className="icon">{icon}</div>
    <h3>{title}</h3>
    {message && <p className="mt-1">{message}</p>}
  </div>
);
